import { createAction } from 'typesafe-actions';

export const fetchCmsNavigationRequest = createAction('cms/NAVIGATION_FETCH_REQUEST')();
export const fetchCmsNavigationSuccess = createAction('cms/NAVIGATION_FETCH_SUCCESS')<Responses.CmsNavigation>();
export const fetchCmsNavigationFailure = createAction('cms/NAVIGATION_FETCH_FAILURE')();
